import type { ConfigureFormState, NotificationChannel, NotificationSystem } from "../Types/NotificationTypes";

export const DEFAULT_FORM: ConfigureFormState = {
  period: "daily",
  comparison_period: "wow",
  operator: "gt",
  threshold_value: "",
  threshold_value_upper: "",
  email: false,
  push: false,
  in_app: false,
  platforms: [],
  campaigns: [],
  threshold_type: "absolute",
  social_platforms: [],
  targets: [],
  cities: [],
  products: [],
};

export const FALLBACK_SECTION_ICON = "/Icons/notif-web-analytics.svg";

export const SECTION_ICONS: Record<string, string> = {
  sales: "/Icons/notif-sales.svg",
  paid_media: "/Icons/notif-insights.svg",
  social: "/Icons/notif-social.svg",
  web_analytics: "/Icons/notif-web-analytics.svg",
};

export const OP_SYMBOL: Record<string, string> = {
  gt: ">",
  gte: "≥",
  lt: "<",
  lte: "≤",
};

export const PLATFORM_LABELS: Record<string, string> = {
  meta_ads: "Meta",
  google_ads: "Google",
};

export const PAID_MEDIA_METRIC_PLATFORM_RESTRICTIONS: Record<string, string[]> = {
  cost_per_purchase: ["meta_ads"],
  cost_per_acquisition: ["google_ads"],
  paid_view: ["meta_ads"],
};

export const NEGATIVE_THRESHOLD_ALLOWED_KEYS: Partial<Record<NotificationSystem, string[]>> = {
  sales: ["revenue", "revenue_growth"],
  social: ["follower_growth"],
};

export const CHANNEL_TABLE_LABEL_KEY: Record<NotificationChannel, string> = {
  email: "email",
  push: "push",
  in_app: "inApp",
};

export const UNIT_SYMBOLS: Record<string, string> = {
  percentage: "%",
  seconds: "s",
};

export const ALL_NOTIFICATIONS_PAGE_SIZE = 10;

export type NotificationPresetFilter = "today" | "thisWeek" | "lastWeek";
export type NotificationListFilter = NotificationPresetFilter | "dateRange";

export const FILTER_TO_DATE_RANGE: Record<
  NotificationPresetFilter,
  "today" | "this_week" | "last_week"
> = {
  today: "today",
  thisWeek: "this_week",
  lastWeek: "last_week",
};
